/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Per_MonthInputs */

const en_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const id_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/bln`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {Pricing_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_per_month = /** @type {((inputs?: Pricing_Per_MonthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Per_MonthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_per_month(inputs)
	return en_pricing_per_month(inputs)
});